/*
  Free gift sync: keeps one "Night Balm - Free Gift" ($0) cart line per
  Subscribe & Save line. Adds it when a subscription enters the cart,
  matches quantity to the number of subscription lines, removes it when
  the last subscription leaves. The paid Night Balm product is unaffected.
*/
(function () {
  var GIFT_HANDLE = 'night-balm-free-gift';
  var giftVariantId = null;
  var syncing = false;
  var queued = false;

  function getGiftVariant() {
    if (giftVariantId) return Promise.resolve(giftVariantId);
    return fetch('/products/' + GIFT_HANDLE + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p && p.variants && p.variants.length) giftVariantId = p.variants[0].id;
        return giftVariantId;
      })
      .catch(function () { return null; });
  }

  function rerenderCart() {
    // Same re-render the theme uses, but without forcing the drawer open.
    fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var form = document.getElementById('AjaxCartForm');
        var freshForm = doc.getElementById('AjaxCartForm');
        if (form && freshForm) {
          form.innerHTML = freshForm.innerHTML;
          if (form.ajaxifyCartItems) form.ajaxifyCartItems();
          document.querySelectorAll('[data-header-cart-count]').forEach(function (elm) {
            elm.textContent = form.querySelector('[data-cart-count]').textContent;
          });
          document.querySelectorAll('[data-header-cart-total]').forEach(function (elm) {
            elm.textContent = form.querySelector('[data-cart-total]').textContent;
          });
        }
        var subtotal = document.getElementById('AjaxCartSubtotal');
        var freshSubtotal = doc.getElementById('AjaxCartSubtotal');
        if (subtotal && freshSubtotal) subtotal.innerHTML = freshSubtotal.innerHTML;
      })
      .catch(function () {});
  }

  function finishSync() {
    syncing = false;
    if (queued) {
      queued = false;
      setTimeout(sync, 300);
    }
  }

  function sync() {
    if (syncing) { queued = true; return; }
    syncing = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var subLines = 0;
        var giftLine = null;
        (cart.items || []).forEach(function (item) {
          var props = item.properties || {};
          for (var key in props) {
            if (key.toLowerCase() === 'purchase type' && String(props[key]).toLowerCase() === 'subscribe and save') {
              subLines += item.quantity;
            }
          }
          if (item.handle === GIFT_HANDLE) giftLine = item;
        });

        if (giftLine && giftLine.quantity === subLines) return null;
        if (!giftLine && subLines === 0) return null;

        if (!giftLine) {
          return getGiftVariant().then(function (variantId) {
            if (!variantId) return null;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: subLines, properties: { _jb_free_gift: 'true' } })
            }).then(function () { return true; });
          });
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftLine.key, quantity: subLines })
        }).then(function () { return true; });
      })
      .then(function (changed) {
        if (changed) {
          rerenderCart();
          setTimeout(checkRenderedGift, 1500);
        }
      })
      .catch(function () {})
      .then(finishSync, finishSync);
  }

  // Re-check after any cart mutation made anywhere in the theme.
  var originalFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = originalFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      result.then(function () {
        setTimeout(sync, 250);
        setTimeout(checkRenderedGift, 2000);
      }, function () {});
    }
    return result;
  };

  // The theme re-renders the drawer on its own after quantity changes, and
  // that render can land AFTER ours with stale gift data. Watch the drawer:
  // whenever the rendered gift quantity disagrees with the actual cart,
  // re-render again (no-ops once they match, so it cannot loop).
  var renderCheckTimer = null;
  function checkRenderedGift() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftLine = (cart.items || []).filter(function (i) { return i.handle === GIFT_HANDLE; })[0];
        var actualQty = giftLine ? giftLine.quantity : 0;
        var rendered = document.querySelector('#AjaxCartForm [data-jb-gift-qty]');
        var renderedQty = rendered ? parseInt(rendered.getAttribute('data-jb-gift-qty'), 10) || 0 : 0;
        if (renderedQty !== actualQty) rerenderCart();
      })
      .catch(function () {});
  }

  function watchDrawer() {
    var form = document.getElementById('AjaxCartForm');
    if (!form || !window.MutationObserver) return;
    new MutationObserver(function () {
      clearTimeout(renderCheckTimer);
      renderCheckTimer = setTimeout(checkRenderedGift, 500);
    }).observe(form, { childList: true, subtree: true });
  }

  function boot() {
    setTimeout(sync, 800);
    watchDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
